import React from 'react';

import { useStyles } from './style';
import {
  Box,
} from '@material-ui/core';
import {
  ExpressCheckoutElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { ToastService } from '../../../../shared/services/toastService';
import { usePurchaseUnlimitedSupplierMutation } from '../../../../api/user';

interface Props {
  isYearly?: boolean;
  newPlan?: string;
  showActivatedPopup: () => void;
}

export const PaymentServices: React.FC<Props> = ({ newPlan, isYearly = true, showActivatedPopup }) => {
  const classes = useStyles();
  const stripe = useStripe();
  const elements = useElements();
  const [purchaseUnlimitedSupplier] = usePurchaseUnlimitedSupplierMutation();

  const handleSuccessPayment = () => {
    showActivatedPopup();
  };

  const confirmCardPayment = async (secret?: string | null) => {
    if (!secret) {
      handleSuccessPayment();
      return;
    }
    const paymentIntentRes = await stripe?.retrievePaymentIntent(secret as string);
    if (paymentIntentRes?.paymentIntent?.status !== 'requires_confirmation') {
      handleSuccessPayment();
      return;
    }
    const confirmPayment = await stripe?.confirmCardPayment(secret);
    if (confirmPayment?.error) {
      ToastService.error(confirmPayment.error.message || 'Payment failed');
    } else {
      handleSuccessPayment();
    }
  };

  const onExpressCheckoutConfirm = async (event: any) => {
    if (!stripe || !elements) {
      return;
    }

    await elements.submit();

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      elements,
    });

    if (error) {
      ToastService.error(error?.message || 'Payment failed');
      return;
    }

    if (paymentMethod?.id) {
      purchaseUnlimitedSupplier({
        payment_method: paymentMethod.id,
        payment_type: newPlan as string,
        payment_interval: isYearly ? 'year' : 'month',
      }).then((res) => {
        if ('data' in res && res.data?.success) {
          confirmCardPayment(res.data?.client_secret);
        }
      });
    } else {
      ToastService.error('Payment failed');
    }
  };

  return (
  <Box className={classes.paymentServices}>
    <ExpressCheckoutElement
      onConfirm={onExpressCheckoutConfirm}
      options={{
        wallets: {
          applePay: 'always',
          googlePay: 'always',
        },
      }}
    />
    <div className={classes.orText}>OR</div>
  </Box>
)};
